import { render, staticRenderFns } from "./CourseTimeDialog.vue?vue&type=template&id=623e3c10&scoped=true"
import script from "./CourseTimeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseTimeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CourseTimeDialog.vue?vue&type=style&index=0&id=623e3c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e3c10",
  null
  
)

export default component.exports